import PipelineServiceNest from '@/bundles/Pipeline/services/PipelineServiceNest';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { httpV2 } from '@/bundles/Http/factory/httpFactory';

function pipelineServiceNestFactory () {
  return new PipelineServiceNest(
    httpV2,
    new ErrorMapper(),
  );
}

export const pipelineServiceNest = pipelineServiceNestFactory();
